import * as React from "react";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { SkeletonText } from "modules/common";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";

interface Props {
    title: string;
    onClose: () => void;
    isLoading?: boolean;
    className?: string;
}

export const ModalHeader: React.FC<Props> = ({ title, onClose, isLoading, className }) => {
    return (
        <div className="modal-header">
            {isLoading ? (
                <SkeletonText width="40%" height="20px" />
            ) : (
                <span className={`modal-header-title ${className ?? ""}`}>{title}</span>
            )}

            <div
                tabIndex={0}
                role="button"
                aria-label="Close"
                onClick={onClose}
                onKeyDown={e => handleKeyDown(e, onClose)}
                className="modal-header-icon-wrapper"
            >
                <CloseIcon className="modal-header-icon" />
            </div>
        </div>
    );
};
